import { createRouter, createWebHashHistory, RouteLocationNormalized, RouteRecordRaw } from "vue-router";
import LayoutIndex from "@/layout/layoutIndex.vue";
import { useMainStore, useStore } from "@/store";
import layoutMainVue from "@/layout/layoutMain.vue";
import { getQueryVariable } from "@/utils";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    component: LayoutIndex,
    children: [
      {
        path: "/main",
        name: "main",
        component: () => import("@/views/main/mainIndex.vue"),
      },
      {
        path: "/",
        component: layoutMainVue,
        children: [
          {
            path: "/accountNumberList",
            name: "accountNumberList",
            component: () => import("@/components/invoice/LoginAccountNumberList.vue"),
          },
        ],
      },
    ],
  },
  {
    path: "/login",
    name: "login",
    component: () => import("@/layout/loginIndex.vue"),
  },
  {
    path: "/remind",
    name: "remind",
    component: () => import("@/layout/remindIndex.vue"),
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

router.beforeEach(async (to, form, next) => {
  if (!["remind"].includes(to.name as string)) await judgePower(to, form);

  next();
});

/** 判断权限 */
const judgePower = (to: RouteLocationNormalized, form: RouteLocationNormalized): Promise<void> => {
  return new Promise(async (resolve, reject) => {
    console.groupCollapsed("判断权限", to);
    const query = getQueryVariable();
    const store = useStore();
    store.setCorpId(query.corpId);
    const token = store.getToken;
    console.log(to, form, token);
    console.log(location.href);
    console.log(query);

    try {
      console.log(!token && to.name != "login");

      if (!token && to.name != "login") router.replace({ name: "login" });
      else if (to.name == "login") token && router.replace({ name: "main", params: { type: "home" } });

      resolve();
    } catch {
      reject();
    }
    console.groupEnd();
  });
};
export default router;
